"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionActionName = void 0;
var TransactionActionName;
(function (TransactionActionName) {
    TransactionActionName["EntryFee"] = "Entry Fee";
    TransactionActionName["EntryPlatformFee"] = "Entry Platform Fee";
    TransactionActionName["Win"] = "Win";
    TransactionActionName["Withdrawal"] = "Withdrawal";
    TransactionActionName["PlatformFee"] = "Platform Fee";
    TransactionActionName["PlatformFeeWithdrawal"] = "Platform Fee Withdrawal";
    TransactionActionName["SeedAmount"] = "Seed Amount";
    TransactionActionName["SeedPlatformFee"] = "Seed Platform Fee";
    TransactionActionName["SeedWithdrawal"] = "Seed Withdrawal";
    TransactionActionName["SeedPlatformFeeWithdrawal"] = "Seed Platform Fee Withdrawal";
    TransactionActionName["OrganizerFee"] = "Organizer Fee";
    TransactionActionName["PrizesExternal"] = "Prizes External";
    TransactionActionName["DepositFunds"] = "Add Funds";
    TransactionActionName["PlatformDepositFunds"] = "Platform Add Funds";
    TransactionActionName["WithdrawalFunds"] = "Withdraw Funds";
    TransactionActionName["WithdrawalFundsCancel"] = "Cancel Withdraw Funds";
    TransactionActionName["WithdrawalFundsFee"] = "Withdraw Funds Fee";
    TransactionActionName["PaypalWithdrawalFunds"] = "PayPal Withdraw Funds";
    TransactionActionName["PaypalWithdrawalFundsFee"] = "PayPal Withdraw Funds Fee";
    TransactionActionName["PaypalWithdrawalFundsRejection"] = "Rejection PayPal Withdraw Funds";
    TransactionActionName["PaypalWithdrawalFundsFeeRejection"] = "Rejection PayPal Withdraw Funds Fee";
    TransactionActionName["SwapBuy"] = "Swap Buy";
    TransactionActionName["SwapSell"] = "Swap Sell";
    TransactionActionName["SwapFee"] = "Swap Fee";
    TransactionActionName["AffiliateProgramRegistrationReward"] = "Registration Reward";
    TransactionActionName["AffiliateProgramCommissionPayout"] = "Affiliate Program Commission";
    TransactionActionName["EntryFeeReward"] = "Entry Fee With Reward Balance";
    TransactionActionName["WithdrawalReward"] = "Withdrawal To Reward Balance";
})(TransactionActionName = exports.TransactionActionName || (exports.TransactionActionName = {}));
//# sourceMappingURL=transaction-action-name.js.map